import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { HeaderBlockLogos } from './headerBlockLogos'
import { HeaderBlockPrices } from './headerBlockPrices'
import { clientAirlineLogoPath } from 'app/apiService'
import { DFModal } from 'app/components/common/modal'
import { CallToBookSection } from 'sections/callToBookSection'

import styles from './headerBlock.module.scss'
import { useGTM } from 'app/GTM'

const Card = ({ location = {}, currency, price: locationPrice, active, airlines, airline }) => {
  const [formIsOpen, setFormIsOpen] = useState(false)
  const destination = location.name
  const price = locationPrice

  const GTM = useGTM()

  const showForm = () => {
    GTM.trackEvent('CallToBookModal_Opened')
    setFormIsOpen(true)
  }

  const closeForm = () => {
    GTM.trackEvent('CallToBookModal_Closed')
    setFormIsOpen(false)
  }

  const airlineLogo = airline ? (
    <span className={styles.airlineText}>
      with&nbsp;
      <img
        className={styles.airlineLogo}
        src={clientAirlineLogoPath(airline.code)}
        alt={airline.name}
      />
    </span>
  ) : null

  const SaleMessage = () => {
    if (new Date() < new Date('2021-12-27T00:00:00.000-08:00')) {
      return (
        <>
          <span>Christmas Flight Sale 2021 is ON.&nbsp;</span>
          <span> Book now to save more!</span>
        </>
      )
    }
    return (
      <>
        <span>On Sale this Week.&nbsp;</span>
        <span>Hurry to Book While Offer Lasts!</span>
      </>
    )
  }
  const formModal = (
    <DFModal
      id="CallToBookModal"
      isOpen={formIsOpen}
      className={`${styles.modal__header_content} ${styles.modal__header_form}`}
      contentLabel="Inquiry Form"
      onClose={closeForm}
    >
      <CallToBookSection location="callToBook" />
    </DFModal>
  )

  return (
    <div
      className={`${styles.headerBlockContainer__card} ${
        !active ? styles.headerBlockContainer__card_hidden : ''
      }`}
    >
      <div className={styles.clickable} onClick={showForm}>
        <div>
          <h1 className={styles.headerBlockContainer__title}>
            <div className={styles.headerBlockContainer__subtitle}>
              Discount Fares from US: {airlineLogo}
            </div>
            <span>to {destination}</span>
          </h1>
          <div className={styles.headerBlockContainer_prices}>
            <HeaderBlockPrices
              currency={currency}
              oldPrice={price.old.value}
              newPrice={price.value}
            />
            <div className={styles.headerBlockContainer__sale}>
              <SaleMessage />
            </div>
          </div>
        </div>
      </div>
      {formModal}
      {airlines ? <HeaderBlockLogos logos={airlines} /> : ''}
    </div>
  )
}

const HeaderBlock = (props) => {
  const { currency, location, price, airline, regions, airlines, hasImage } = props
  const [active, setActive] = useState(0)

  const changeSlide = (index, slug) => {
    setActive(index)
    window.location.hash = slug
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && regions) {
      let { hash } = window.location
      const index = Object.keys(regions).findIndex(
        (regionKey) => regions[regionKey].slug === hash.replace('#', '')
      )
      if (index >= 0) {
        setActive(index)
      }
    }
  }, [])

  return (
    <section className={`${styles.headerBlockContainer} ${hasImage ? styles.withImage : null}`}>
      {regions ? (
        <ul className={styles.headerBlockContainer__nav}>
          {Object.keys(regions).map((regionKey, index) => {
            const { name, slug } = regions[regionKey]
            return (
              <li key={regionKey} className={styles.headerBlockContainer__navItem}>
                <button
                  className={`${styles.headerBlockContainer__navButton} ${
                    active === index ? styles.headerBlockContainer__navButton_active : ''
                  }`}
                  onClick={() => changeSlide(index, slug)}
                >
                  {name}
                </button>
              </li>
            )
          })}
        </ul>
      ) : (
        ''
      )}
      {regions ? (
        Object.keys(regions).map((regionKey, index) => {
          const { name, price } = regions[regionKey]
          const location = { name }
          return (
            <Card
              active={index === active}
              location={location}
              currency={currency}
              price={price}
              key={regionKey}
              airline={airline}
            />
          )
        })
      ) : (
        <Card
          active
          location={location}
          currency={currency}
          price={price}
          airlines={airlines}
          airline={airline}
        />
      )}
    </section>
  )
}

HeaderBlock.propTypes = {
  destination: PropTypes.string,
  currency: PropTypes.string,
  oldPrice: PropTypes.string,
  location: PropTypes.object,
  price: PropTypes.object,
  regions: PropTypes.object,
  airlines: PropTypes.array,
  airline: PropTypes.object,
}

export { HeaderBlock }
